import React, { useEffect, useState } from 'react';
import { formatMoney, signupLabel } from './cartAnalyticsFormat';

export const BREAKDOWNS = [
  ['country', 'Country'],
  ['city', 'City'],
  ['device', 'Device'],
  ['browser', 'Browser'],
  ['signup_method', 'Sign-up method'],
  ['product', 'Product'],
  ['item', 'Item'],
  ['price_band', 'Price band'],
  ['promo', 'Promo code'],
  ['carrier', 'Delivery option'],
];

export default function BreakdownTabs({
  by, onChange, rows, loading, ccy, search, onSearch,
}) {
  // The search text is typed locally and sent to the API (which searches every group, not just the
  // top 50 shown) shortly after the user stops typing. The parent clears it when the tab changes.
  const [text, setText] = useState(search || '');
  useEffect(() => { setText(search || ''); }, [search]);
  useEffect(() => {
    if (text.trim() === (search || '')) return undefined;
    const t = setTimeout(() => onSearch(text.trim()), 350);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  const data = (rows || []).filter((r) => !ccy || r.ccy === ccy);
  const total = data.reduce((s, r) => s + (Number(r.atc_events) || 0), 0) || 1;
  const show = (r) => (by === 'signup_method' ? signupLabel(r.label) : (r.label === null || r.label === '' ? 'Unknown' : r.label));

  return (
    <div className="card shadow-sm mb-3 ca-breakdown-card">
      <div className="card-body">
        <div className="ca-table-section-header">
          <p className="ca-table-title">Top 50 by add-to-cart count</p>
          <p className="ca-table-subtitle">Breakdown of cart activity by dimension. Figures match the applied date range and filters.</p>
        </div>
        <ul className="nav ca-tabs">
          {BREAKDOWNS.map(([k, l]) => (
            <li className="nav-item" key={k}>
              <button type="button" className={`nav-link ${by === k ? 'active' : ''}`} onClick={() => onChange(k)}>{l}</button>
            </li>
          ))}
        </ul>
        <div className="ca-search">
          <input
            type="search"
            className="form-control form-control-sm"
            placeholder={`Search ${((BREAKDOWNS.find((b) => b[0] === by) || [])[1] || '').toLowerCase()}…`}
            value={text}
            maxLength={60}
            onChange={(e) => setText(e.target.value)}
            aria-label="Search this breakdown"
          />
        </div>
        {loading && <div className="ca-loading mb-2">Loading…</div>}
        <div className="table-responsive">
          <table className="table table-sm ca-breakdown-table mb-0">
            <thead>
              <tr>
                <th>{(BREAKDOWNS.find((b) => b[0] === by) || [])[1]}</th>
                <th className="text-right" style={{ whiteSpace: 'nowrap' }}>Add to cart</th>
                <th style={{ width: 160 }}>Share</th>
                <th className="text-right">Items</th>
                <th className="text-right">Carts</th>
                <th className="text-right" style={{ whiteSpace: 'nowrap' }}>Customers / visitors</th>
                <th className="text-right" style={{ whiteSpace: 'nowrap' }}>Cart value</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr><td colSpan={7} className="text-center py-4 ca-empty-cell">{search ? `Nothing matches "${search}" in this range` : 'No data for this range'}</td></tr>
              ) : data.map((r) => {
                const pct = ((Number(r.atc_events) || 0) / total) * 100;
                return (
                  <tr key={`${r.label}-${r.ccy}`}>
                    <td>{show(r)}</td>
                    <td className="text-right">{Number(r.atc_events).toLocaleString('en-US')}</td>
                    <td>
                      <div className="ca-share"><div className="ca-share-bar" style={{ width: `${pct}%` }} /></div>
                      <small className="text-muted">{pct.toFixed(1)}%</small>
                    </td>
                    <td className="text-right">{Number(r.items_qty).toLocaleString('en-US')}</td>
                    <td className="text-right">{Number(r.carts).toLocaleString('en-US')}</td>
                    <td className="text-right">{Number(r.customers).toLocaleString('en-US')}</td>
                    <td className="text-right">{formatMoney(r.cart_value, r.ccy)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
